__turbopack_context__.v({
  "mark": "reality-model-mark-module__a4Z8gW__mark",
  "outline": "reality-model-mark-module__a4Z8gW__outline",
});
